import React, { useState, useEffect } from "react";
import { isEmpty } from "lodash";

import {
  Container, Row, Col, Card, Alert, CardBody, Button, Label, Input, FormFeedback, Form,
} from "reactstrap";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

// Redux
import { useSelector, useDispatch } from "react-redux";

// Your assets and actions
import avatar from "../../assets/images/users/avatar-1.jpg";
import { fetchUserById, updateUserProfile } from "../../slices/thunks"; 
import { createSelector } from "reselect";
import { getAuthUser } from "../../helpers/utils";
import { useTranslation } from "react-i18next";

const UserProfile = () => {
  const dispatch = useDispatch();
  const { user } = getAuthUser();
  const { t, i18n } = useTranslation();

  const selectLayoutState = (state) => state.Profile;
  const userprofileData = createSelector(
    selectLayoutState,
    (state) => ({
      profile: state.user,
      success: state.success,
      error: state.error
    })
  );

  const { profile, success, error } = useSelector(userprofileData);

  useEffect(() => {
    if (user?.UserId) {
      dispatch(fetchUserById({ UserId: user.UserId }));
    }
  }, [dispatch, user?.UserId]);

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      first_name: profile.FirstName || '',
      last_name: profile.LastName || '',
      email: profile.Email || '',
    },
    validationSchema: Yup.object({
      first_name: Yup.string().required(t("EnterFirstNameerr")),
      last_name: Yup.string().required(t("EnterLastNameerr")),
      email: Yup.string().email("Invalid Email").required(t("PleaseEmailErr")),
    }),
    onSubmit: (values) => {
      dispatch(updateUserProfile({
        UserId: user.UserId,
        FirstName: values.first_name,
        LastName: values.last_name,
        Email: values.email,
      }));
    }
  });

  document.title = "Profile | Alitqan";

  return (
    <React.Fragment>
      <div className="page-content mt-lg-5">
        <Container fluid>
          <Row>
            <Col lg="12">
              {error && <Alert color="danger">{error}</Alert>}
              {success && <Alert color="success">{t("ProfileUpdatedSuccess")}</Alert>}

              <Card>
                <CardBody>
                  <div className="d-flex">
                    <div className="mx-3">
                      <img
                        src={avatar}
                        alt=""
                        className="avatar-md rounded-circle img-thumbnail"
                      />
                    </div>
                    <div className="flex-grow-1 align-self-center">
                      <div className="text-muted">
                        <h5>{profile.FullName}</h5>
                        <p className="mb-1">Email Id : {profile.Email}</p>
                        <p className="mb-1">Contact No. : {`${profile.CountryDialCode}${profile.Mobile}`}</p>
                        <p className="mb-0">Role : {profile.RoleNameEn}</p>
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <h4 className="card-title mb-4">{t("UpdateProfile")}</h4>

          <Card>
            <CardBody>
              <Form
                className="form-horizontal"
                onSubmit={(e) => {
                  e.preventDefault();
                  validation.handleSubmit();
                }}
              >
                <div className="form-group">
                  <Label className="form-label">{t("FirstName")}</Label>
                  <Input
                    name="first_name"
                    className="form-control"
                    placeholder="Enter First Name"
                    type="text"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.first_name}
                    invalid={validation.touched.first_name && !!validation.errors.first_name}
                  />
                  {validation.touched.first_name && validation.errors.first_name && (
                    <FormFeedback>{validation.errors.first_name}</FormFeedback>
                  )}

                  <Label className="form-label mt-3">{t("LastName")}</Label>
                  <Input
                    name="last_name"
                    className="form-control"
                    placeholder="Enter Last Name"
                    type="text"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.last_name}
                    invalid={validation.touched.last_name && !!validation.errors.last_name}
                  />
                  {validation.touched.last_name && validation.errors.last_name && (
                    <FormFeedback>{validation.errors.last_name}</FormFeedback>
                  )}

                  <Label className="form-label mt-3">{t("Email")}</Label>
                  <Input
                    name="email"
                    className="form-control"
                    placeholder="Enter Email"
                    type="email"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.email}
                    invalid={validation.touched.email && !!validation.errors.email}
                  />
                  {validation.touched.email && validation.errors.email && (
                    <FormFeedback>{validation.errors.email}</FormFeedback>
                  )}
                </div>

                <div className="text-center mt-4">
                  <Button type="submit" color="danger">
                  {t("UpdateProfile")}
                  </Button>
                </div>
              </Form>
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default UserProfile;
